import { useState } from "react";
import { Menu, X, ChevronRight, Shield, Heart, Award, Users, Phone, Mail, Clock, Check } from "lucide-react";
import '../index.css';

export default function Quote() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    age: "",
    insuranceType: "health",
    coverage: "",
    existingConditions: "",
    message: ""
  });
  const [formStep, setFormStep] = useState(1);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const nextStep = () => {
    setFormStep(formStep + 1);
    window.scrollTo(0, 0);
  };

  const prevStep = () => {
    setFormStep(formStep - 1);
    window.scrollTo(0, 0);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    // Simulate form submission with timeout
    setTimeout(() => {
      setSubmitting(false);
      setSubmitted(true);
      // Reset form after submission
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        age: "",
        insuranceType: "health",
        coverage: "",
        existingConditions: "",
        message: ""
      });
    }, 1500);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        {/* Announcement bar */}
        <div className="bg-gradient-to-r from-[#002D62] to-[#0077B6] text-white text-center py-2 text-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="font-semibold mr-2">Limited Time:</span> Get up to 30% off your first year of coverage. 
            <a href="/promotion" className="font-bold underline ml-1 hover:text-blue-100 transition-colors">Learn more</a>
          </div>
        </div>
        
        <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20">
            <div className="flex items-center">
              <div className="flex-shrink-0 flex items-center">
                <div className="mr-2 text-[#0077B6]">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-8 h-8">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <span className="text-2xl font-extrabold bg-gradient-to-r from-[#002D62] to-[#0077B6] bg-clip-text text-transparent">Optimal Actuarion</span>
              </div>
              <nav className="hidden md:ml-10 md:flex md:space-x-8">
                <a href="/" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Home</a>
                <a href="/#/about" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">About Us</a>
                <a href="/#/services" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Services</a>
                <a href="/#/quote" className="text-[#002D62] font-bold border-b-2 border-[#0077B6] px-1 pt-2 pb-1 transition-colors">Get a Quote</a>
                <a href="/#/faqs" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">FAQs</a>
                <a href="/#/testimonials" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Testimonials</a>
                <a href="/#/contact" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Contact</a>
              </nav>
            </div>
            <div className="flex items-center">
              <div className="hidden md:flex md:items-center md:space-x-4">
                <a href="/login" className="text-[#002D62] font-medium hover:text-[#0077B6] mr-4 transition-colors">Login</a>
                <a href="/quote" className="bg-gradient-to-r from-[#0077B6] to-[#00A8E8] text-white px-6 py-3 rounded-md font-bold hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200">
                  Get a Free Quote
                </a>
              </div>
              <div className="flex md:hidden">
                <button
                  type="button"
                  className="text-gray-700 hover:text-[#002D62] transition-colors"
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  aria-expanded={mobileMenuOpen}
                >
                  {mobileMenuOpen ? (
                    <X className="h-6 w-6" />
                  ) : (
                    <Menu className="h-6 w-6" />
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg animate-fadeIn">
            <div className="pt-2 pb-4 space-y-1 px-4">
              <a href="/" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Home</a>
              <a href="/#/about" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">About Us</a>
              <a href="/#/services" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Services</a>
              <a href="/#/quote" className="block py-2 text-[#002D62] font-bold border-l-4 border-[#0077B6] pl-3">Get a Quote</a>
              <a href="/#/faqs" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">FAQs</a>
              <a href="/#/testimonials" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Testimonials</a>
              <a href="/#/contact" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Contact</a>
              <div className="pt-4 pb-2 space-y-2">
                <a href="/login" className="block text-center text-[#002D62] font-medium hover:text-[#0077B6] py-2 transition-colors">
                  Login
                </a>
                <a href="/quote" className="w-full flex items-center justify-center bg-gradient-to-r from-[#0077B6] to-[#00A8E8] text-white px-4 py-3 rounded-md font-bold shadow-md transition-all hover:shadow-lg">
                  Get a Free Quote
                </a>
              </div>
            </div>
          </div>
        )}
      </header>

      <main>
        {/* Page Header */}
        <div className="bg-[#E8F1F9]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
            <div className="text-center">
              <h1 className="text-4xl font-bold text-[#002D62]">Get Your Free Insurance Quote</h1>
              <p className="mt-4 text-lg text-gray-700 max-w-3xl mx-auto">
                Complete the form below to receive a personalized insurance quote. Our experts will review your information and provide you with the best options for your needs.
              </p>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="md:flex md:space-x-8">
            {/* Sidebar */}
            <div className="md:w-1/4 mb-8 md:mb-0">
              <div className="bg-[#F4F4F4] rounded-lg p-6 sticky top-24">
                <h3 className="text-xl font-bold text-[#002D62] mb-4">Quote Process</h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <div className={`flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center ${formStep >= 1 ? 'bg-[#0077B6] text-white' : 'bg-gray-300 text-gray-500'}`}>
                      {formStep > 1 ? <Check className="h-5 w-5" /> : "1"}
                    </div>
                    <span className={`ml-3 ${formStep === 1 ? 'font-medium text-[#002D62]' : 'text-gray-600'}`}>
                      Personal Information
                    </span>
                  </div>
                  <div className="flex items-center">
                    <div className={`flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center ${formStep >= 2 ? 'bg-[#0077B6] text-white' : 'bg-gray-300 text-gray-500'}`}>
                      {formStep > 2 ? <Check className="h-5 w-5" /> : "2"}
                    </div>
                    <span className={`ml-3 ${formStep === 2 ? 'font-medium text-[#002D62]' : 'text-gray-600'}`}>
                      Insurance Details
                    </span>
                  </div>
                  <div className="flex items-center">
                    <div className={`flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center ${formStep >= 3 ? 'bg-[#0077B6] text-white' : 'bg-gray-300 text-gray-500'}`}>
                      {formStep > 3 ? <Check className="h-5 w-5" /> : "3"}
                    </div>
                    <span className={`ml-3 ${formStep === 3 ? 'font-medium text-[#002D62]' : 'text-gray-600'}`}>
                      Additional Information
                    </span>
                  </div>
                  <div className="flex items-center">
                    <div className={`flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center ${submitted ? 'bg-[#0077B6] text-white' : 'bg-gray-300 text-gray-500'}`}>
                      {submitted ? <Check className="h-5 w-5" /> : "4"}
                    </div>
                    <span className={`ml-3 ${submitted ? 'font-medium text-[#002D62]' : 'text-gray-600'}`}>
                      Confirmation
                    </span>
                  </div>
                </div>

                <div className="mt-8 pt-6 border-t border-gray-300">
                  <h3 className="text-lg font-medium text-[#002D62] mb-4">Need Help?</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <Phone className="h-5 w-5 text-[#0077B6]" />
                      <span className="ml-3 text-gray-600">972-891-8635</span>
                    </div>
                    <div className="flex items-center">
                      <Mail className="h-5 w-5 text-[#0077B6]" />
                      <span className="ml-3 text-gray-600">OptimalActuarion@gmail.com</span>
                    </div>
                    <div className="flex items-center">
                      <Clock className="h-5 w-5 text-[#0077B6]" />
                      <span className="ml-3 text-gray-600">Mon-Fri: 9:00 AM - 5:00 PM</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="md:w-3/4">
              <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
                {submitted ? (
                  <div className="text-center py-12">
                    <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100">
                      <Check className="h-8 w-8 text-green-600" />
                    </div>
                    <h2 className="mt-6 text-2xl font-bold text-[#002D62]">Thank You!</h2>
                    <p className="mt-4 text-lg text-gray-600">
                      Your quote request has been successfully submitted. One of our insurance experts will contact you within 1-2 business days to discuss your personalized options.
                    </p>
                    <div className="mt-8">
                      <button
                        onClick={() => {setSubmitted(false); setFormStep(1);}}
                        className="mt-4 bg-[#0077B6] hover:bg-[#002D62] text-white py-3 px-8 rounded-md font-medium transition-colors"
                      >
                        Submit Another Request
                      </button>
                    </div>
                  </div>
                ) : (
                  <form onSubmit={formStep === 3 ? handleSubmit : e => e.preventDefault()}>
                    {formStep === 1 && (
                      <div>
                        <h2 className="text-2xl font-bold text-[#002D62] mb-6">Personal Information</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div>
                            <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
                              First Name *
                            </label>
                            <input
                              type="text"
                              id="firstName"
                              name="firstName"
                              value={formData.firstName}
                              onChange={handleChange}
                              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#0077B6] focus:border-[#0077B6] focus:outline-none"
                              required
                            />
                          </div>
                          <div>
                            <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
                              Last Name *
                            </label>
                            <input
                              type="text"
                              id="lastName"
                              name="lastName"
                              value={formData.lastName}
                              onChange={handleChange}
                              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#0077B6] focus:border-[#0077B6] focus:outline-none"
                              required
                            />
                          </div>
                          <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                              Email Address *
                            </label>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#0077B6] focus:border-[#0077B6] focus:outline-none"
                              required
                            />
                          </div>
                          <div>
                            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                              Phone Number *
                            </label>
                            <input
                              type="tel"
                              id="phone"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#0077B6] focus:border-[#0077B6] focus:outline-none"
                              required
                            />
                          </div>
                          <div>
                            <label htmlFor="age" className="block text-sm font-medium text-gray-700 mb-1">
                              Age *
                            </label>
                            <input
                              type="number"
                              id="age"
                              name="age"
                              min="18"
                              max="120"
                              value={formData.age}
                              onChange={handleChange}
                              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#0077B6] focus:border-[#0077B6] focus:outline-none"
                              required
                            />
                          </div>
                        </div>

                        <div className="mt-8 flex justify-end">
                          <button
                            type="button"
                            onClick={nextStep}
                            className="bg-[#0077B6] hover:bg-[#002D62] text-white py-3 px-6 rounded-md font-medium flex items-center transition-colors"
                          >
                            Next Step
                            <ChevronRight className="ml-2 h-5 w-5" />
                          </button>
                        </div>
                      </div>
                    )}

                    {formStep === 2 && (
                      <div>
                        <h2 className="text-2xl font-bold text-[#002D62] mb-6">Insurance Details</h2>
                        <div className="space-y-6">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Insurance Type *
                            </label>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              <div 
                                className={`border-2 ${formData.insuranceType === 'health' ? 'border-[#0077B6] bg-blue-50' : 'border-gray-300 bg-white'} rounded-lg p-4 cursor-pointer transition-all`}
                                onClick={() => setFormData({...formData, insuranceType: 'health'})}
                              >
                                <div className="flex items-center">
                                  <div className={`h-5 w-5 rounded-full border-2 ${formData.insuranceType === 'health' ? 'border-[#0077B6]' : 'border-gray-400'} flex items-center justify-center`}>
                                    {formData.insuranceType === 'health' && <div className="h-3 w-3 rounded-full bg-[#0077B6]"></div>}
                                  </div>
                                  <div className="ml-3">
                                    <h3 className="text-lg font-medium text-gray-900">Health Insurance</h3>
                                    <p className="text-sm text-gray-500">Medical coverage for individuals and families</p>
                                  </div>
                                </div>
                              </div>
                              
                              <div 
                                className={`border-2 ${formData.insuranceType === 'life' ? 'border-[#0077B6] bg-blue-50' : 'border-gray-300 bg-white'} rounded-lg p-4 cursor-pointer transition-all`}
                                onClick={() => setFormData({...formData, insuranceType: 'life'})}
                              >
                                <div className="flex items-center">
                                  <div className={`h-5 w-5 rounded-full border-2 ${formData.insuranceType === 'life' ? 'border-[#0077B6]' : 'border-gray-400'} flex items-center justify-center`}>
                                    {formData.insuranceType === 'life' && <div className="h-3 w-3 rounded-full bg-[#0077B6]"></div>}
                                  </div>
                                  <div className="ml-3">
                                    <h3 className="text-lg font-medium text-gray-900">Life Insurance</h3>
                                    <p className="text-sm text-gray-500">Financial protection for your loved ones</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          <div>
                            <label htmlFor="coverage" className="block text-sm font-medium text-gray-700 mb-1">
                              Desired Coverage Amount *
                            </label>
                            <select
                              id="coverage"
                              name="coverage"
                              value={formData.coverage}
                              onChange={handleChange}
                              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#0077B6] focus:border-[#0077B6] focus:outline-none"
                              required
                            >
                              <option value="">Select coverage amount</option>
                              {formData.insuranceType === 'health' ? (
                                <>
                                  <option value="basic">Basic ($5,000 - $10,000)</option>
                                  <option value="standard">Standard ($10,000 - $25,000)</option>
                                  <option value="premium">Premium ($25,000 - $50,000)</option>
                                  <option value="comprehensive">Comprehensive ($50,000+)</option>
                                </>
                              ) : (
                                <>
                                  <option value="25k">$25,000</option>
                                  <option value="50k">$50,000</option>
                                  <option value="100k">$100,000</option>
                                  <option value="250k">$250,000</option>
                                  <option value="500k">$500,000</option>
                                  <option value="1m">$1,000,000+</option>
                                </>
                              )}
                            </select>
                          </div>
                          
                          {formData.insuranceType === 'health' && (
                            <div>
                              <label htmlFor="existingConditions" className="block text-sm font-medium text-gray-700 mb-1">
                                Do you have any pre-existing medical conditions?
                              </label>
                              <textarea
                                id="existingConditions"
                                name="existingConditions"
                                value={formData.existingConditions}
                                onChange={handleChange}
                                rows={3}
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#0077B6] focus:border-[#0077B6] focus:outline-none"
                                placeholder="Please list any pre-existing conditions (optional)"
                              />
                            </div>
                          )}
                        </div>

                        <div className="mt-8 flex justify-between">
                          <button
                            type="button"
                            onClick={prevStep}
                            className="border border-[#0077B6] text-[#0077B6] hover:bg-gray-50 py-3 px-6 rounded-md font-medium flex items-center transition-colors"
                          >
                            <ChevronRight className="mr-2 h-5 w-5 rotate-180" />
                            Previous
                          </button>
                          <button
                            type="button"
                            onClick={nextStep}
                            className="bg-[#0077B6] hover:bg-[#002D62] text-white py-3 px-6 rounded-md font-medium flex items-center transition-colors"
                          >
                            Next Step
                            <ChevronRight className="ml-2 h-5 w-5" />
                          </button>
                        </div>
                      </div>
                    )}

                    {formStep === 3 && (
                      <div>
                        <h2 className="text-2xl font-bold text-[#002D62] mb-6">Additional Information</h2>
                        <div className="space-y-6">
                          <div>
                            <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                              Additional Information or Questions
                            </label>
                            <textarea
                              id="message"
                              name="message"
                              value={formData.message}
                              onChange={handleChange}
                              rows={5}
                              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#0077B6] focus:border-[#0077B6] focus:outline-none"
                              placeholder="Let us know about any specific questions or concerns..."
                            />
                          </div>
                          
                          <div className="bg-blue-50 p-4 rounded-md border border-blue-200">
                            <h3 className="text-lg font-medium text-[#002D62] mb-2">Review Your Information</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                              <div>
                                <p><span className="font-medium">Name:</span> {formData.firstName} {formData.lastName}</p>
                                <p><span className="font-medium">Email:</span> {formData.email}</p>
                                <p><span className="font-medium">Phone:</span> {formData.phone}</p>
                                <p><span className="font-medium">Age:</span> {formData.age}</p>
                              </div>
                              <div>
                                <p><span className="font-medium">Insurance Type:</span> {formData.insuranceType === 'health' ? 'Health Insurance' : 'Life Insurance'}</p>
                                <p><span className="font-medium">Coverage Amount:</span> {formData.coverage}</p>
                                {formData.insuranceType === 'health' && formData.existingConditions && (
                                  <p><span className="font-medium">Pre-Existing Conditions:</span> {formData.existingConditions}</p>
                                )}
                              </div>
                            </div>
                          </div>
                          
                          <div className="flex items-start">
                            <input
                              id="terms"
                              name="terms"
                              type="checkbox"
                              className="h-4 w-4 text-[#0077B6] focus:ring-[#0077B6] border-gray-300 rounded mt-1"
                              required
                            />
                            <label htmlFor="terms" className="ml-2 block text-sm text-gray-700">
                              I agree that Optimal Actuarion may contact me by email or phone regarding my insurance quote request. 
                              I understand that my information will be used in accordance with the privacy policy.
                            </label>
                          </div>
                        </div>

                        <div className="mt-8 flex justify-between">
                          <button
                            type="button"
                            onClick={prevStep}
                            className="border border-[#0077B6] text-[#0077B6] hover:bg-gray-50 py-3 px-6 rounded-md font-medium flex items-center transition-colors"
                          >
                            <ChevronRight className="mr-2 h-5 w-5 rotate-180" />
                            Previous
                          </button>
                          <button
                           type="submit"
                           className={`bg-gradient-to-r from-[#0077B6] to-[#00A8E8] text-white py-3 px-8 rounded-md font-bold flex items-center ${submitting ? 'opacity-70 cursor-not-allowed' : 'hover:shadow-lg transform hover:-translate-y-0.5'} transition-all duration-200`}
                           disabled={submitting}
                         >
                           {submitting ? (
                             <>
                               <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                 <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                 <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                               </svg>
                               Processing...
                             </>
                           ) : (
                             <>
                               Submit Quote Request
                               <ChevronRight className="ml-2 h-5 w-5" />
                             </>
                           )}
                         </button>
                       </div>
                     </div>
                   )}
                 </form>
               )}
             </div>
           </div>
         </div>
       </div>

       {/* Features Section */}
       <div className="bg-[#F4F9FC] py-12 mt-12">
         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
           <h2 className="text-3xl font-bold text-center text-[#002D62] mb-12">Why Choose Optimal Actuarion?</h2>
           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
             <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center">
               <Shield className="h-12 w-12 text-[#0077B6] mb-4" />
               <h3 className="text-xl font-bold text-[#002D62] mb-2">Comprehensive Coverage</h3>
               <p className="text-gray-600">
                 We offer a wide range of insurance options tailored to your specific needs and budget.
               </p>
             </div>
             <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center">
               <Award className="h-12 w-12 text-[#0077B6] mb-4" />
               <h3 className="text-xl font-bold text-[#002D62] mb-2">Expert Guidance</h3>
               <p className="text-gray-600">
                 Our experienced team provides personalized advice to help you make informed decisions.
               </p>
             </div>
             <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center">
               <Users className="h-12 w-12 text-[#0077B6] mb-4" />
               <h3 className="text-xl font-bold text-[#002D62] mb-2">Customer Satisfaction</h3>
               <p className="text-gray-600">
                 Our clients trust us for our exceptional service and ongoing support.
               </p>
             </div>
           </div>
         </div>
       </div>
     </main>

     {/* Footer */}
     <footer className="bg-[#002D62] text-white pt-12 pb-6">
       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
         <div className="grid grid-cols-1 md:grid-cols-4 gap-8 pb-8 border-b border-blue-700">
           <div>
             <h3 className="text-xl font-bold mb-4">Optimal Actuarion</h3>
             <p className="text-blue-200 mb-4">
               Providing exceptional insurance solutions with personalized service since 2005.
             </p>
             <div className="flex space-x-4">
               <a href="#" className="text-blue-200 hover:text-white transition-colors">
                 <span className="sr-only">Facebook</span>
                 <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                   <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                 </svg>
               </a>
               <a href="#" className="text-blue-200 hover:text-white transition-colors">
                 <span className="sr-only">Twitter</span>
                 <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                   <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                 </svg>
               </a>
               <a href="#" className="text-blue-200 hover:text-white transition-colors">
                 <span className="sr-only">LinkedIn</span>
                 <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                   <path fillRule="evenodd" d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" clipRule="evenodd" />
                 </svg>
               </a>
             </div>
           </div>
           <div>
             <h3 className="text-lg font-medium mb-4">Quick Links</h3>
             <ul className="space-y-2">
               <li><a href="/" className="text-blue-200 hover:text-white transition-colors">Home</a></li>
               <li><a href="/about" className="text-blue-200 hover:text-white transition-colors">About Us</a></li>
               <li><a href="/services" className="text-blue-200 hover:text-white transition-colors">Services</a></li>
               <li><a href="/quote" className="text-blue-200 hover:text-white transition-colors">Get a Quote</a></li>
               <li><a href="/faqs" className="text-blue-200 hover:text-white transition-colors">FAQs</a></li>
             </ul>
           </div>
           <div>
             <h3 className="text-lg font-medium mb-4">Insurance Products</h3>
             <ul className="space-y-2">
               <li><a href="/health-insurance" className="text-blue-200 hover:text-white transition-colors">Health Insurance</a></li>
               <li><a href="/life-insurance" className="text-blue-200 hover:text-white transition-colors">Life Insurance</a></li>
               <li><a href="/home-insurance" className="text-blue-200 hover:text-white transition-colors">Home Insurance</a></li>
               <li><a href="/auto-insurance" className="text-blue-200 hover:text-white transition-colors">Auto Insurance</a></li>
               <li><a href="/business-insurance" className="text-blue-200 hover:text-white transition-colors">Business Insurance</a></li>
             </ul>
           </div>
           <div>
             <h3 className="text-lg font-medium mb-4">Contact Us</h3>
             <address className="not-italic text-blue-200">
               <p>123 Insurance Avenue</p>
               <p>Dallas, TX 75001</p>
               <p className="mt-3">Phone: (972) 891-8635</p>
               <p>Email: OptimalActuarion@gmail.com</p>
             </address>
           </div>
         </div>
         <div className="pt-6 text-center text-sm text-blue-300">
           <p>&copy; {new Date().getFullYear()} Optimal Actuarion. All rights reserved.</p>
           <p className="mt-2">
             <a href="/privacy" className="hover:text-white transition-colors">Privacy Policy</a>
             {" | "}
             <a href="/terms" className="hover:text-white transition-colors">Terms of Service</a>
           </p>
         </div>
       </div>
     </footer>
   </div>
 );
}